

































































































import VueI18n from 'vue-i18n';
import { Component, Vue } from "vue-property-decorator";
import { IGroupedFormDTO, ICalculatorForm } from '../utils/interfaces';

@Component
export default class CalculatorForm extends Vue {
  public valid = false;
  public bedsSpacing = 0;
  public cropSpacing = 0;
  public distWaterSource = 0;
  public slopeOrientation = 0;
  public solarOrientation = 0;
  public cropType = "";
  public soilType = "";
  public irrigationType = "";
  public waterConsumption = 0;
  public waterSourceType = "";
  public waterSourcePipeDiameter = 0;
  public minimalPressure = 0;
  public maximumPressure = 0;
  public doYouHaveAPump = false;
  public pumpPreference = "";
  public snackbarText: VueI18n.TranslateResult = "";
  public groupedForm: IGroupedFormDTO = null!;

  constructor() {
    super();
  }

  public get fieldLength(): number {
    return this.$store.state.calculatorForm.fieldLength;
  }

  public set fieldLength(value: number) {
    this.$store.commit("setCalculatorFormProperty", value);
  }

  public get fieldWidth(): number {
    return this.$store.state.calculatorForm.fieldWidth;
  }

  public set fieldWidth(value: number) {
    this.$store.commit("setCalculatorFormProperty", value);
  }

  public get fieldOrientation(): number {
    return this.$store.state.calculatorForm.fieldOrientation;
  }

  public set fieldOrientation(value: number) {
    this.$store.commit("setCalculatorFormProperty", value);
  }

  public async confirmOrder(event: Event): Promise<void> {
    const calculatorForm = this.buildCalculatorForm();
    this.$store.dispatch("commitOrder", calculatorForm);
    this.$store.state.isModalVisible = true;
  }

  public buildCalculatorForm(): ICalculatorForm {
    const calculatorForm = {
      fieldLength: this.fieldLength,
      fieldWidth: this.fieldWidth,
      fieldOrientation: this.fieldOrientation,
      bedsSpacing: this.bedsSpacing,
      cropSpacing: this.cropSpacing,
      distWaterSource: this.distWaterSource,
      slopeOrientation: this.slopeOrientation,
      solarOrientation: this.solarOrientation,
      cropType: this.cropType,
      soilType: this.soilType,
      irrigationType: this.irrigationType,
      waterConsumption: this.waterConsumption,
      waterSourceType: this.waterSourceType,
      waterSourcePipeDiameter: this.waterSourcePipeDiameter,
      minimalPressure: this.minimalPressure,
      maximumPressure: this.maximumPressure,
      doYouHaveAPump: this.doYouHaveAPump,
      pumpPreference: this.pumpPreference,
    };
    return calculatorForm;
  }
}
